import C5CompraItemModel from "./C5CompraItemModel";

export default class C5CompraModel {
  public compraId: string = "";
  public data: Date = new Date();
  public totalCompra: number = 0;
  public meioPagamento: string = "";
  public status: string = "";
  public statusId: number = 0;
  public statusAtualizacao: Date = new Date();
  public dataRetirada: Date = new Date();
  public horaRetirada: string = "";
  public mensagemRetirada: string = "";
  public descricaoRetirada: string = "";
  public enderecoCompleto: string = "";
  public bairro: string = "";
  public cidadeEstado: string = "";
  public cep: string = "";
  public lojaId: string | null = "";
  public produtos: C5CompraItemModel[] = [];

  public static toModel(item: any): C5CompraModel {

    const produtos: C5CompraItemModel[] = item.SalesItem.map((si: any) => {
      return C5CompraItemModel.toModel(si);
    });

    return {
      compraId: item.SaleID,
      data: new Date(Date.parse(item.Date)),
      totalCompra: item.TotalAmount,
      meioPagamento: item.PaymentMethod,
      status: item.Status,
      dataRetirada: new Date(Date.parse(item.DateDeleveryWindow)),
      horaRetirada: item.HourDeleveryWindow,
      enderecoCompleto: item.CompleteAddress,
      bairro: item.Neighborhood,
      cidadeEstado: item.CityAndState,
      cep: item.ZipCode,
      produtos,
    } as C5CompraModel;
  }
}
